import { WorkableApplicationStepGuard } from '@features/applications/components/workable-application-step-guard.tsx';
import AgreeStep from '@features/wizard/components/agree/agree-step.tsx';
import OtpStep from '@features/wizard/components/otp/otp-step.tsx';
import QuestionsStep from '@features/wizard/components/questions/questions-step.tsx';
import StartStep from '@features/wizard/components/start/start-step.tsx';
import Wizard from '@features/wizard/components/wizard.tsx';
import { IDENTITY_STEP_NAME } from '@features/wizard/types/identity-step-name.ts';
import { IdentityStepResponse } from '@features/wizard/types/identity-step-response.ts';
import React from 'react';

import { Application, KbaQuestion } from '@/types/api.ts';

type WizardStepsProps = {
  application: Application;
};

const WizardSteps = ({ application }: WizardStepsProps) => {
  const [questions, setQuestions] = React.useState<KbaQuestion[]>([]);
  const handleStepComplete = (stepResponse: IdentityStepResponse) => {
    if (stepResponse.questions) {
      setQuestions(stepResponse.questions);
    }
  };

  return (
    <WorkableApplicationStepGuard application={application}>
      <Wizard initialStep={IDENTITY_STEP_NAME.AGREE}>
        <AgreeStep
          application={application}
          stepName={IDENTITY_STEP_NAME.AGREE}
          onNextStep={handleStepComplete}
        />
        <StartStep
          application={application}
          stepName={IDENTITY_STEP_NAME.START}
          onNextStep={handleStepComplete}
        />
        <OtpStep
          application={application}
          stepName={IDENTITY_STEP_NAME.OTP}
          onNextStep={handleStepComplete}
        />
        <QuestionsStep
          application={application}
          stepName={IDENTITY_STEP_NAME.QUESTIONS}
          questions={questions}
        />
      </Wizard>
    </WorkableApplicationStepGuard>
  );
};

export default WizardSteps;
